import React, { useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import axios from 'axios';
import { Link } from "react-router-dom"; 
import { toast } from 'react-toastify';

const Edit = ({ show, onClose, packageTimelineId, onUpdated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const toTitleCase = (str) =>
        str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());

    const [formData, setFormData] = useState({
        packagetimeline_name: '',
        score: '',
        days: '',
        all_days: true,
        specification: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (packageTimelineId && show) {
            axios.get(`${baseURL}/package-timeline/${packageTimelineId}`)
                .then(response => {
                    const data = response.data.data;
                    const convertToBool = val => val === "0" || val === 0;

                    setFormData({
                        packagetimeline_name: data.packagetimeline_name || '',
                        score: data.score?.toString() || '',
                        days: data.days?.toString() || '',
                        all_days: data.all_days === 0,
                        specification: data.specification === 0,
                        sunday: convertToBool(data.sunday),
                        monday: convertToBool(data.monday),
                        tuesday: convertToBool(data.tuesday),
                        wednesday: convertToBool(data.wednesday),
                        thursday: convertToBool(data.thursday),
                        friday: convertToBool(data.friday),
                        saturday: convertToBool(data.saturday)
                    });
                })
                .catch(error => {
                    console.error("Failed to fetch data", error);
                });
        }
    }, [packageTimelineId, show]);

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        let newValue = type === 'checkbox' ? checked : value;

        if (name === 'packagetimeline_name') {
            newValue = toTitleCase(value).slice(0, 50);
        }
        if (name === 'score') {
            newValue = value.replace(/\D/g, '').slice(0, 2);
        }
        if (name === 'days') {
            newValue = value.replace(/\D/g, '').slice(0, 4);
        }

        setFormData(prev => ({
            ...prev,
            [name]: newValue
        }));

        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleRadioToggle = (type) => {
        if (type === 'alldays') {
            setFormData(prev => ({
                ...prev,
                all_days: true,
                specification: false,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                all_days: false,
                specification: true
            }));
        }
    };

    const handleSubmit = () => {
        const newErrors = {};

        if (!formData.packagetimeline_name.trim()) {
            newErrors.packagetimeline_name = "Package Timeline name is required.";
        } else if (formData.packagetimeline_name.trim().length > 50) {
            newErrors.packagetimeline_name = "Package Timeline name cannot exceed 50 characters.";
        }

        if (!formData.score || isNaN(formData.score) || parseInt(formData.score) <= 0) {
            newErrors.score = "Please enter a valid score.";
        }

        if (!formData.days || isNaN(formData.days) || parseInt(formData.days) <= 0) {
            newErrors.days = "Please enter a valid number of days.";
        }

        if (formData.specification) {
            const hasSelectedDay = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
                .some(day => formData[day]);
            if (!hasSelectedDay) {
                newErrors.specificationDays = "Please select at least one day.";
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);
        const updatedBy = parseInt(localStorage.getItem("user_id"), 10) || 1;
        const payload = {
            packagetimeline_name: formData.packagetimeline_name.trim(),
            score: formData.score,
            days: formData.days,
            all_days: formData.all_days ? 0 : 1,
            specification: formData.specification ? 0 : 1,
            sunday: formData.sunday ? 0 : 1,
            monday: formData.monday ? 0 : 1,
            tuesday: formData.tuesday ? 0 : 1,
            wednesday: formData.wednesday ? 0 : 1,
            thursday: formData.thursday ? 0 : 1,
            friday: formData.friday ? 0 : 1,
            saturday: formData.saturday ? 0 : 1,
            updated_by: updatedBy // <-- add updated_by here
        };

        axios.put(`${baseURL}/package-timeline/${packageTimelineId}`, payload)
            .then(() => {
                setLoading(false);
                onUpdated();
                onClose();
                toast.success("Package Timeline updated successfully!");
            })
            .catch(error => {
                setLoading(false);
                if (error.response?.status === 409 && error.response?.data?.message) {
                    setErrors({ packagetimeline_name: error.response.data.message });
                } else if (error.response?.data?.errors) {
                    const serverErrors = {};
                    for (let key in error.response.data.errors) {
                        serverErrors[key] = error.response.data.errors[key][0];
                    }
                    setErrors(serverErrors);
                } else {
                    console.error("Failed to update", error);
                    toast.error("Failed to update package timeline.");
                }
            });
    };

    return (
        <Modal className="modal fade" show={show} size="md" onHide={onClose}>
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Package Timeline</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Package Timeline<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="packagetimeline_name"
                                value={formData.packagetimeline_name}
                                onChange={handleChange}
                                maxLength={50}
                            />
                            {errors.packagetimeline_name && <span className="text-danger">{errors.packagetimeline_name}</span>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Score<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="score"
                                value={formData.score}
                                onChange={handleChange}
                            />
                            {errors.score && <span className="text-danger">{errors.score}</span>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">No Of Days<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="days"
                                value={formData.days}
                                onChange={handleChange}
                            />
                            {errors.days && <span className="text-danger">{errors.days}</span>}
                        </div>

                        <div className="col-lg-12">
                            <div className='mb-4 mt-2'>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="timeline_type"
                                        checked={formData.all_days}
                                        onChange={() => handleRadioToggle('alldays')}
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">All Days</label>
                                </div>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="timeline_type"
                                        checked={formData.specification}
                                        onChange={() => handleRadioToggle('specification')}
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">Specification</label>
                                </div>

                                {formData.specification && (
                                    <div className='row mt-2'>
                                        {['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map(day => (
                                            <div key={day} className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name={day}
                                                    checked={formData[day]}
                                                    onChange={handleChange}
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    {day.charAt(0).toUpperCase() + day.slice(1)}
                                                </label>
                                            </div>
                                        ))}
                                        {errors.specificationDays && (
                                            <div className="col-12">
                                                <span className="text-danger">{errors.specificationDays}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            {loading ? 'Updating...' : 'Update Package Timeline'} <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Edit;
